<template>
  <el-row>
    <b>{{ row.name }}</b>
    <el-row v-if="row.parts || row.checkWays || row.purpose">
      <span v-if="row.parts" class="right-pad">
        检查部位：<span class="danger">{{ row.parts | partsFilter }}</span>
      </span>
      <span v-if="row.checkWays" class="right-pad">
        检查方式：<span class="danger">{{ row.checkWays }}</span>
      </span>
      <span v-if="row.purpose" class="right-pad">
        检查目的：<span class="danger">{{ row.purpose }}</span>
      </span>
    </el-row>
    <el-row v-if="row.symptom">
      <span class="right-pad">
        临床症状及特征：<span class="danger">{{ row.symptom }}</span>
      </span>
    </el-row>
  </el-row>
</template>
<script>
  export default {
    props: {
      row: Object,
    },
    filters: {
      partsFilter(val) {
        try {
          val = JSON.parse(val).join(",");
          return val;
        } catch (error) {
          return val;
        }
      },
    },
  };
</script>
